// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3tDsf","title":"Info_title__1LUY9","links":"Info_links__3ChZ-","link":"Info_link__3J-AK","logo":"Info_logo__3ZFtA"};